import React from 'react'
import PropTypes from 'prop-types'

import { trimExcerpt } from 'core/helpers/wp-data-helpers'

const ConversationListItem = props => {
  const active = props.conversation && props.conversation.ID === props.item.ID
  const viewed = props.viewed.indexOf(props.item.ID) !== -1

  return (
    <li
      className={`conversation-list-item ${active ? 'is-active' : ''} ${viewed ? '' : 'is-unread'}`}
      onClick={props.handleSelect.bind(null, props.item)}
    >
      <div className="conversation-list-item-text">
        <div className="conversation-list-item-title type-body mod-md-body">
          {props.item.post_title}
        </div>
        <p className="conversation-list-item-excerpt type-body mod-md-body">
          {trimExcerpt(props.item.post_excerpt)}
        </p>
      </div>
    </li>
  )
}

ConversationListItem.propTypes = {
  item: PropTypes.object.isRequired,
  handleSelect: PropTypes.func.isRequired,
  conversation: PropTypes.object,
  viewed: PropTypes.array.isRequired
}

export default ConversationListItem
